export const DayRoutesMainView = () => <>Hello</>
